import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import Index from "@/components/Index.vue"
import LandingPage from "@/views/LandingPage.vue"
import Login from "@/views/Login.vue"
import VideoTour from "@/views/VideoTour.vue"
import { checkToken, requireAuth } from '@/auth'

const linkActiveClass = 'kab-active-class'

Vue.use(VueRouter);

const routes = [
  {
    path: "/welcome",
    name: "LandingPage",
    component: LandingPage,
    beforeEnter: checkToken
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: checkToken
  },
  {
    path: "/joinEvent",
    name: "JoinEvent",
    component: () => import("../views/JoinEvent.vue"),
    beforeEnter: checkToken
  },
  {
    path: "/tour",
    name: "VideoTour",
    component: VideoTour,
    beforeEnter: requireAuth
  },
  {
    path: "/",
    name: "Index",
    component: Index,
    beforeEnter: checkToken,
    redirect: { name: 'LandingPage' },
    children: [
      {
        path: "/studios",
        name: "Studios",
        component: () =>
          import("../views/Studios.vue")
      },
      {
        path: "/studios/:id",
        name: "StudioDetails",
        component: () =>
          import("../components/Studios/StudioDetails.vue")
      },
      {
        path: "/apprentices",
        name: "Apprentices",
        component: () =>
          import("../views/Apprentices.vue")
      },
      {
        path: "/masters",
        name: "Masters",
        component: () =>
          import("../views/Masters.vue")
      }
    ]

  },
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass,
  scrollBehavior() {
    window.scrollTo(0,0);
  }
});

export default router;
